import { render, staticRenderFns } from "./TeacherSearchPage.vue?vue&type=template&id=96b88c7a&scoped=true&"
import script from "./TeacherSearchPage.vue?vue&type=script&lang=js&"
export * from "./TeacherSearchPage.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSearchPage.vue?vue&type=style&index=0&id=96b88c7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b88c7a",
  null
  
)

export default component.exports